export const CONTACT_UK = 'contacting_boge_uk';
export const CONTACT_UK_TITLE = 'Contacting BOGE UK';
export const CONTACT_DE = 'kontaktformular_boge_deutschland';
export const CONTACT_DE_TITLE = 'Kontaktformular BOGE Deutschland';
export const CONTACT_USA = 'contacting_boge_usa';
export const CONTACT_USA_TITLE = 'Contacting BOGE USA';
